import React, {useContext, useEffect, useState} from 'react';
import { useSelector } from 'react-redux';
import { getParentRouteKey, KeyMappings } from '../../../utilities/generateRouterKeys';
import Building from '../configurations/building';
import Buildings from "../configurations/buildings";
import Biometric from './biometric';
import BiometricPreset from './biometricPreset';
import CommonZone from "./commonZone";
import CommonZones from './commonZones';
import ControllerPreset from './controllerPreset';
import DeviceTimePattern from './deviceTimePattern';
import DeviceTimePatterns from './deviceTimePatterns';
import Door from './door';
import Doors from "./doors";
import Lifts from './lifts';
import Hardware from './hardware';
import HardwarePresets from "./hardwarePresets";
import IODevicePreset from './ioDevicePreset';
import IOModule from './ioModule';
import Lock from './lock';
import LockPreset from './lockPreset';
import MasterController from './master-controller';
import Reader from './reader';
import ReaderPreset from './readerPreset';
import ReasonCode from './reasonCode';
import ReasonCodes from './reasonCodes';
import TimeTriggeredActions from "./timetriggeredactions";
import Zone from './zone';
import Zones from "./zones";
import Floors from "./floors";
import Lift from './lift';
import Floor from './floor';

function getPageForRoute(key, stateProps, selectedTab, setSelectedTab) {
    const selected = {
        'zone': <Zone />,
        'zones': <Zones />,
        'reason-codes': <ReasonCodes />,
        'reason-code': <ReasonCode />,
        'doors': <Doors />,
        'door': <Door />,
        'floors': <Floors />,
        'floor': <Floor />,
        'lifts': <Lifts />,
        'lift': <Lift />,
        'device-time-patterns': <DeviceTimePatterns />,
        'device-time-pattern': <DeviceTimePattern />,
        'common-zones': <CommonZones />,
        'time-triggered-actions': <TimeTriggeredActions />,
        'presets': <HardwarePresets
            selected={selectedTab}
            setSelected={setSelectedTab}
        />,
        'common-zone': <CommonZone />,
        'master-controller': <MasterController />,
        'reader': <Reader />,
        'lock': <Lock />,
        // 'locker': <Locker />,
        'reader-preset': <ReaderPreset />,
        'biometric-preset': <BiometricPreset/>,
        'controller-preset': <ControllerPreset />,
        'device-preset': <IODevicePreset />,
        // 'engine': <Engine />,
        'io-module': <IOModule />,
        'biometric': <Biometric />,
        'building': <Building />,
        'buildings': <Buildings />,
        'lock-preset': <LockPreset />,
        // 'locker-preset': <LockerPreset />,
    }[key];

    if (selected) {
        return selected;
    }
    return <Hardware
        selected={selectedTab}
        setSelected={setSelectedTab}
    />
}

function getKeyFromPath(path) {
    const contentKey = 3;
    const key = path.split("/")[contentKey];
    return key;
}

// this maps the parent route key to the child route key
// allows us to controll resetting of tabs when the parent route changes
// e.g. when we change from /zones to /buildings, we want to reset the tabs
const keyMappings: KeyMappings = {
    'presets': ['reader-preset', 'biometric-preset', 'controller-preset', 'device-preset', 'lock-preset', 'presets'],
    'zones': ['zone', 'zones'],
    'reason-codes': ['reason-codes', 'reason-code'],
    'doors': ['door', 'doors'],
    'lifts': ['lift', 'lifts'],
    'device-time-patterns': ['device-time-patterns', 'device-time-pattern'],
    'common-zones': ['common-zone', 'common-zones'],
    'time-triggered-actions': ['time-triggered-actions'],
    'hardware': ['reader', 'lock', 'io-module', 'biometric', 'master-controller'],
    'buildings': ['building', 'buildings'],
    'floors': ['floor', 'floors'],
};

const HardwareIndex = () => {
    const pageProps = useSelector((state: any) => state.router.location.state);
    const page = useSelector((state: any) => state.router.location.pathname);

    const [selectedTab, setSelectedTab] = useState<number>(0);
    const [parentRoute, setParentRoute] = useState<string>('');

    const updateTabIndex = () => {
        const key = getKeyFromPath(page);
        const currentParentRoute = getParentRouteKey(key, keyMappings);

        if (parentRoute !== currentParentRoute) { // if the parent route has changed, reset the tab index
            setSelectedTab(0)
            setParentRoute(currentParentRoute)
        }
    }

    useEffect(() => { // this should only be used for anything that depends on a page change
        updateTabIndex();
    }, [page]);

    return getPageForRoute(getKeyFromPath(page), pageProps,selectedTab,setSelectedTab);
};

export default HardwareIndex;
